import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DivLayout from 'components/sales/divLayout/divLayout';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const VendorForm = ({ details, index, handleVal, size, documentUploadUrl, documentUrlData,inputVal=0}) => {
  const inputs = {
    quantity: inputVal,
    document: '',
    actual_qty: inputVal
  };
  const [formData, setData] = useState(inputs);
  const handleFormdata = () => {
    if (formData.quantity !== null) {
      handleVal({
        ...formData,
        service_boq_id: details && details.id ? details.id : '',
      });
    }
  };
  useEffect(() => {
    handleFormdata();
  }, [formData]);
  // console.log('formData ' + JSON.stringify(formData));
  return (
    <FormSectionNew  title={`${localization.serviceDetails} ${index + 1}`}>
      <div className="row mb-4">
        <div className="col-lg-2 col-md-12">
          <strong>{localization.serviceName}</strong>
        </div>
        <div className="col-lg-4 col-md-12">
          {details?.service_name ? details.service_name : localization.na}
        </div>

        <div className="col-lg-2 col-md-12">
          <strong>{localization.description}</strong>
        </div>
        <div className="col-lg-4 col-md-12">
          {details?.description ? details.description : localization.na}
        </div>
      </div>
      <div className='row'>
      <div className='col-lg-2 col-md-12'>
      <ConstantInput
        label={localization.enterQuanity}
        regex={Regex.numericNotZero.test(formData.quantity)}
        type="number"
        maxLength={5}
        minLength={1}
        min={0}
        errorMsg={
          formData.quantity === ''
            ? localization.requiredQuantity
            : localization.enterValidData
        }
        required
        isStarRequired={false}
        handleChange={(value) => setData({ ...formData, quantity: value })}
        value={inputVal}
      />
      </div>
      <div className='col-lg-4 col-md-12'>
      <FileUpload
        id={`addAttachment` + index }
        //multiple="multiple"
        accept=".pdf,.png,.jpg,.jpeg,.doc"
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        onChange={(val) =>
          setData({
            ...formData,
            document: val,
          })
        }
        >
        <span className="btn btn-transparent">
          {localization.uploadAttachment}
        </span>
      </FileUpload>
      </div>
      </div>
    </FormSectionNew>
  );
};

VendorForm.propTypes = {};

export default VendorForm;
